import * as React from 'react';
import FormField, { BaseFormFieldProps } from './FormField';
import TextAreaInput, { TextAreaProps } from '../input/basicInputs/TextAreaInput';

export interface TextAreaFormFieldProps extends BaseFormFieldProps, TextAreaProps {}

class TextAreaFormField extends React.Component<TextAreaFormFieldProps> {
  render() {
    return <FormField {...this.props}>{({ input }) => <TextAreaInput {...input} />}</FormField>;
  }
}

export default TextAreaFormField;
